export enum LocationsSortColumns {
	NAME = 'name',
	ADDRESS = 'address',
	CITY = 'city',
	STATE = 'state',
	PHONE = 'phone',
	REMOTE_NUMBER = 'remoteNumber',
	HOLD_UNIT = 'holdUnit',
	HOLD_COUNT = 'holdCount',
	VIDEO_COUNT = 'videoCount',
	POSTER_COUNT = 'posterCount',
	RADIO_COUNT = 'radioCount',
	WEB_COUNT = 'webCount',
	VIDEO_WALL_COUNT = 'videoWallCount'
}
